import { render } from "./AgencyAdmin.vue?vue&type=template&id=dbff6fc6"
import script from "./AgencyAdmin.vue?vue&type=script&lang=js"
export * from "./AgencyAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__